export default {
  WelcomeMessage: 'Bienvenido a Spore',
  InputDataMessage: 'Ingresa tus datos',
  EmailLabel: 'Correo',
  PasswordLabel: 'Contraseña',
  ForgotPassword: '¿Olvidaste tu contraseña?',
  Enter: 'Ingresar',
  Messages: {
    ErrorLogin: 'Credenciales incorrectas.',
    MissingParams: 'Favor de llenar los campos',
    Alert: 'Alerta',
    Correct: 'Correcto',
    State: 'Estado',
    Required: 'Campo requerido',
    EqualPassword: 'Las contraseñas deben coincidir',
    None: 'Ninguna',
    EnterPassword:'Ingresar contraseña',
    DatesRange: 'La fecha de inicio no puede ser mayor a la del final.',
    NotLuminaries: 'No hay luminarias disponibles para asignar',
    NotAssignedLuminaries: 'No hay luminarias asignadas',
    AlertsCircuit: 'Las alertas configuradas aplicarán a todas las luminarias del circuito',
    AlertsAll: 'Las alertas configuradas aplicarán a todas las luminarias',
    SelectArea: 'Para seleccionar un área, mantenga presionada la tecla CTRL'
  },
  Labels:{
    Back: 'Atrás',
    Min: 'Mínimo',
    Max: 'Máximo',
    Avg: 'Promedio',
    Time: 'Tiempo',
    TimeUnity: 'Unidad de Tiempo',
    DeviceLocation: 'Ubicación del dispositivo',
    Alerts: 'Configuración de Alertas',
    LuminaryInformation: 'Información de luminaria',
    ReportTime: 'Tiempo de reporteo',
    Save: 'Guardar',
    Filter: 'Filtrar',
    DeviceName: 'Nombre del dispositivo',
    User: 'Usuario | Usuarios ',
    UserType: 'Tipo de Usuario',
    Admin: 'Administrador',
    Reader: 'Lector',
    Date: 'Fecha',
    Password: 'Contraseña',
    ConfirmPassword: 'Confirmar contraseña',
    Email: 'Correo',
    LastName: 'Apellido(s)',
    Devices: 'Dispositivo | Dispositivos',
    NotAssigned: 'Sin asignar',
    Assign: 'Asignar',
    Assigned:'Asignados',
    SelectOne:'Selecciona uno',
    AddUser: 'Agregar usuario',
    EditUser: 'Editar usuario',
    Status: 'Estatus',
    Active: 'Activo',
    Inactive: 'Inactivo',
    Alias: 'Alias',
    Type: 'Tipo',
    LastUpdated: 'Última actualización',
    Graphics: 'Gráficas',
    Today: 'Hoy',
    Close: 'Cerrada',
    Open: 'Abierta',
    ConfigView: 'Configurar vista',
    Client:'Cliente',
    Contract: 'Contrato',
    ContactNumber: 'Número de contacto',
    ClientNumber: 'Número de cliente',
    Address:'Dirección',
    Suburb: 'Colonia',
    PostalCode: 'Código Postal',
    City:'Ciudad',
    State:'State',
    Notifications: 'Notificaciones',
    Measurement: 'Medición',
    Percent:'Porcentaje',
    Battery: 'Batería',
    LastCharge: 'Última carga',
    Analog:'Análogo',
    Digital:'Digital',
    ChangeTo:'Cambiar a',
    SeeMore: 'Ver más',
    Second: 'Segundo',
    Last24Hours: 'Últimas 24 horas',
    Serie:'Serie',
    Name:'Nombre',
    LastSeen: 'Última vez visto',
    Gauges: 'Medidores', 
    BatteryLevel: 'Nivel de Batería',
    ApproximateLitersSpent: 'Litros aproximados consumidos',
    DaysHours: 'Horas del día',
    Minimum: 'Mínimo',
    Maximum: 'Máximo',
    Average: 'Promedio',
    Week: 'Semana',
    Month: 'Mes',
    Clean: 'Limpiar',
    TotalNumberOfGauges: 'Número total de medidores',
    To: 'A',
    From: 'De',
    Hours: 'Horas',
    Actives: 'Activos',
    Inactives: 'Inactivos',
    InstallationOK : 'Instalación OK',
    InstallationAlert : 'Alerta Instalación',
    Capacity: 'Capacidad',
    Installed: 'Instalados',
    ErrorInstallation: 'Error de instalación',
    All: 'Todos',
    By: 'por',
    Total: 'Total',
    Range: 'Rango',
    NoData: 'Sin datos',
    Previous: 'Anterior',
    OrderBy:'Ordenar por',
    History: 'Historial',
    Approximate: 'Aproximado',
    ByPage: 'Por página',
    ShowFilters: 'Mostrar filtros',
    HideFilters: 'Ocultar filtros',
    Circuit: 'Circuito',
    CurrentConsumption: 'Consumo actual',
    AccumulatedConsumption: 'Consumo acumulado',
    On: 'Encendido',
    Off: 'Apagado',
    Show: 'Mostrar',
    LuminaryNumber: 'No. Luminaria',
    Voltage: 'Voltaje',
    Relay: 'Relay',
    Current: 'Corriente',
    Attenuation: 'Atenuación',
    LuminaryMeasurements: 'Mediciones de luminaria',
    ActivePower: 'Potencia Activa',
    ReactivePower: 'Potencia Reactiva',
    ApparentPower: 'Potencia Aparente',
    PowerFactor: 'Factor de potencia',
    Power: 'Potencia',
    ActiveEnergy: 'Energía Activa',
    ReactiveEnergy: 'Energía Reactiva',
    Frequency: 'Frecuencia',
    Statistics: 'Estadísticas',
    Color: 'Color',
    LuminariesCount: 'Cantidad de luminarias',
    Cuantity: 'Cantidad',
    ShowControls: 'Mostrar controles',
    HideControls: 'Ocultar controles',
    ShowConfigAlerts: 'Mostrar configuración de alertas',
    HideConfigAlerts: 'Ocultar configuración de alertas',
    Apply: 'Aplicar',
    Accept: 'Aceptar',
    Cancel: 'Cancelar',
    Confirm: 'Confirmar',
    Inclination: 'Inclinación',
    Dimming: 'Intensidad',
    FailureVoltage: 'Error en voltaje',
    FailureCurrent: 'Error en corriente',
    FailureRelay: 'Error en relay',
    FailureDimming: 'Error en intensidad',
    FailureInclination: 'Error de inclinación',
    Alert: 'Alerta',
    LastMonth: 'Último mes',
    LastWeek: 'Última semana',
    Add: 'Agregar',
    Luminaries: 'Luminarias',
    Value: 'Valor',
    NoError: 'Sin error',
    Error: 'Con error',
    Summarized: 'Sumarizados',
    Fullscreen: 'Ver en pantalla completa',
    ExitFullscreen: 'Salir de pantalla completa',
    StatisticsAll: 'Estadísticas de Todas las luminarias',
    StatisticsCircuit: 'Estadísticas Circuito',
    NotAssignedToCircuit: 'No asignadas a un circuito',
    EnabledSelection: 'Habilitar selección',
    AssignToCircuit: 'Asignar a un circuito',
    StartTime: 'Hora Inicio',
    EndTime: 'Hora Fin',
    StartDimming: 'Intensidad Inicio',
    EndDimming: 'Intensidad Fin',
    ControlDimming: 'Control Intensidad',
    Schedule:'Por horario'
  },
  Dashboard:'Tablero',
  Devices: 'Dispositivos',
  Map: 'Mapa',
  Logout: 'Cerrar sesión',
  Users: 'Usuarios',
  Circuits: 'Circuitos'
}
